import { useTranslation } from 'react-i18next';

import useUpdateScheduledMessageMutation from 'components/domain/automation/scheduledMessages/useUpdateScheduledMessageMutation';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { BaseErrorResponse } from 'models/_base';
import { getErrorMessage } from 'utils/axiosExceptionUtils';
import { ScheduledMessagesEditModalFormValues } from './ScheduledMessagesEditModal.schema';

const useScheduledMessagesEditModalFormSubmit = ({
  scheduledMessageUid,
}: {
  scheduledMessageUid: string;
}) => {
  const { t } = useTranslation();
  const modalId = useModalId();
  const { closeModal } = useAppModal();
  const { notifyError, notifySuccess } = useNotify();

  const onError = (error: BaseErrorResponse) => {
    notifyError(
      getErrorMessage({
        apiErrorCode: error.response?.data?.apiErrorCode,
        apiErrorMessage: error.response?.data?.apiErrorMessage ?? '',
        baseKey: 'pageAutomations.triggers.apiErrorCodes.',
        t,
      }),
    );
  };

  const { mutateAsync: updateScheduledMessage } =
    useUpdateScheduledMessageMutation();

  const onSubmit = async (formValues: ScheduledMessagesEditModalFormValues) => {
    const { templateContent_htmlContent, templateSubject } = formValues;

    try {
      await updateScheduledMessage(
        {
          body: templateContent_htmlContent,
          subject: templateSubject,
          scheduledMessageUid,
        },
        {
          onSuccess: () => {
            closeModal(modalId);
            notifySuccess(t('pageAutomations.scheduledMessages.modal.success'));
          },
        },
      );
    } catch (error) {
      onError(error as BaseErrorResponse);
    }
  };

  return { onSubmit };
};

export default useScheduledMessagesEditModalFormSubmit;
